import { useMemo, useState } from 'react';
import { forecastSeries } from '../../../engine/forecastAI';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

export function ForecastPanel() {
  const [series, setSeries] = useState([100000, 98000, 95000, 93000, 92000, 91000]);
  const f = useMemo(() => forecastSeries({ lastValues: series }), [series]);
  const data = [...series.slice(-6), ...f.next].map((v,i)=> ({ d: i+1, v }));
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3">
      <div className="font-orbitron text-evat-gold">3-Month Forecast</div>
      <div className="w-full h-48">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" />
            <XAxis dataKey="d" stroke="#d4af37" />
            <YAxis stroke="#d4af37" />
            <Tooltip contentStyle={{ background:'#000', border:'1px solid #00FF88', color:'#fff' }} />
            <Line type="monotone" dataKey="v" stroke="#00FF88" dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default ForecastPanel;



















